import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Switch } from "@/components/ui/switch";
import { BellRing, Mail } from "lucide-react";

const ROWS = [
  { key: "streak_reminders", icon: BellRing, title: "Daily streak reminder", desc: "A 6pm UK nudge on days you haven't done a rep yet, with your weakest customer suggested." },
  { key: "manager_digest", icon: Mail, title: "Monday team digest", desc: "If you manage a team: every Monday at 8am UK, each rep's sessions, scores, XP and weak spots." },
];

export function NotificationsCard() {
  const { user } = useAuth();
  const [settings, setSettings] = useState(null);
  useEffect(() => { api.get("/notifications/settings").then((r) => setSettings(r.data)).catch(() => setSettings({})); }, []);

  const toggle = async (key, value) => {
    setSettings((s) => ({ ...s, [key]: value }));
    try { const r = await api.patch("/notifications/settings", { [key]: value }); setSettings(r.data); toast.success(value ? "Emails turned on" : "Emails turned off"); }
    catch { toast.error("Couldn't save that"); setSettings((s) => ({ ...s, [key]: !value })); }
  };

  return (
    <div className="card-surface rounded-2xl p-6" data-testid="account-notifications-card">
      <h2 className="font-semibold text-slate-900">Email reminders</h2>
      <p className="text-sm text-slate-600 mt-1">Sent to {user?.email || "your account email"}. Switch any off at any time.</p>
      <div className="mt-4 divide-y divide-slate-100">
        {ROWS.map(({ key, icon: Icon, title, desc }) => (
          <div key={key} className="flex items-start gap-3 py-3 first:pt-0 last:pb-0">
            <div className="w-9 h-9 rounded-xl bg-emerald-50 text-emerald-700 flex items-center justify-center shrink-0"><Icon className="w-4 h-4" /></div>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-semibold text-slate-900">{title}</div>
              <div className="text-xs text-slate-500 mt-0.5 leading-relaxed">{desc}</div>
            </div>
            <Switch checked={!!settings?.[key]} disabled={!settings} onCheckedChange={(v) => toggle(key, v)} data-testid={`notif-toggle-${key}`} />
          </div>
        ))}
      </div>
    </div>
  );
}
